import React from 'react';

import PropTypes from 'prop-types';

import { ButtonPrimary } from '../../../../shared/components';
import { LogoPlataform, Row, DivText, CustomDeleteButton } from './styles';

import DeleteIcon from '@mui/icons-material/Delete';

export function RowPlataform({
  name,
  logo,
  onClick,
  integrationStatus,
  onDelete,
}) {
  return (
    <Row>
      <LogoPlataform image={logo} />
      <DivText>
        <strong>{name}</strong>
        {integrationStatus ? (
          <span>Sua conta está ativada</span>
        ) : (
          <span>Sua conta não está ativada</span>
        )}
      </DivText>
      <ButtonPrimary.Normal
        color="#777777"
        type="outline"
        label={integrationStatus ? 'Editar dados' : 'Linkar sua conta'}
        onClick={onClick}
      />
      <CustomDeleteButton
        onClick={integrationStatus ? onDelete : null}
        disable={!integrationStatus}
      >
        <DeleteIcon />
      </CustomDeleteButton>
    </Row>
  );
}

RowPlataform.propTypes = {
  name: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  integrationStatus: PropTypes.bool.isRequired,
};
